import React, { useState } from "react";
import styles from "./sobre_mim_robertinhotattooarts.module.scss";
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import FacebookIcon from "../../icons/facebookIcon.tsx";
import Instagram1 from './src/instagram1.png';
import Instagram2 from './src/instagram2.png';

const Sobre_mim_robertinhotattooarts: React.FC = () => {
    const [showInstagrams, setShowInstagrams] = useState(false);

    return (
        <div className={styles.sobre_mim_robertinhotattooarts}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/robertinhotattooarts" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Sobre mim</h1>
            </div>

            {/* CONTEÚDO */}
            <div className={styles.content}>
                <div className={styles.imageContainer}>
                    <img src={require("./src/img_sobremim.png")} alt="Rafael Cubone" />
                </div>
                <h2>Roberto Herrero</h2>
                <p>
                    Tatuador profissional desde 2010, premiado em convenções de tatuagem, atuando também como jurado e ministrante de workshops.
                    Especialista em diversos estilos, como neo tradicional, old school, oriental, fine line, aquarela, colorido, preto e branco, caligrafia, tribal (maori) e pontilhismo.
                </p>
                <p>
                    Além disso, realiza aplicações de piercing com total segurança e qualidade.
                </p>
                <p>
                    Proprietário do estúdio renomado na região, Robertinho atua há mais de 15 anos oferecendo sempre materiais de alta qualidade e o que há de melhor no mercado, eternizando ideias na pele de seus clientes.
                </p>
                <p>
                    Apaixonado pelo que faz, estuda e se aperfeiçoa constantemente em novas técnicas para entregar trabalhos únicos, personalizados e de excelência a cada cliente.
                </p>
            </div>

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    <a href="https://wa.me/5518997951461?text=Olá, vim pelo link na bio e gostaria de mais informações..." target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><WhatsappIcon height="30" color="#ffffff" /></div>
                            <span>WhatsApp</span>
                        </div>
                    </a>
                    <a href="https://maps.app.goo.gl/gsz8eDGiUeehrH1k7" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><MapsIcon height="30" color="#ffffff" /></div>
                            <span>Localização</span>
                        </div>
                    </a>
                    <a href="https://www.facebook.com/share/1QhqZopD9j/?mibextid=wwXIfr" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><FacebookIcon height="30" color="#ffffff" /></div>
                            <span>Facebook</span>
                        </div>
                    </a>
                    <div onClick={() => setShowInstagrams(true)}>
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><InstagramIcon height="26" color="#ffffff" /></div>
                            <span>Instagram</span>
                        </div>
                    </div>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
            {showInstagrams && (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setShowInstagrams(false)}
                >
                    <div
                        className={styles.modalContent}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className={styles.closeButton}
                            onClick={() => setShowInstagrams(false)}
                        >
                            ✕
                        </button>
                        <h2>Instagram</h2>
                        <div className={styles.modalGrid}>
                            <div className={styles.modalCard}>
                                <img src={Instagram1} />
                                <p>@robertinho_q.o.e.s</p>
                                <a
                                    href="https://www.instagram.com/robertinho_q.o.e.s?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button className={styles.mapButton}>
                                        <InstagramIcon height="18" color="#fff" />
                                        <span>Acessar</span>
                                    </button>
                                </a>
                            </div>
                            <div className={styles.modalCard}>
                                <img src={Instagram2} />
                                <p>@robertinho.tattoo.arts</p>
                                <a
                                    href="https://www.instagram.com/robertinho.tattoo.arts?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button className={styles.mapButton}>
                                        <InstagramIcon height="18" color="#fff" />
                                        <span>Acessar</span>
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div >
    );
};

export default Sobre_mim_robertinhotattooarts;
